// Componente de loading para formulários
"use client";

import {
  Paper,
  Box,
  Typography,
  CircularProgress,
  LinearProgress,
} from "@mui/material";

interface FormLoadingProps {
  title?: string;
  message?: string;
  type?: "circular" | "linear";
}

export default function FormLoading({
  title = "Autenticando...",
  message = "Estamos processando sua solicitação.",
  type = "circular",
}: FormLoadingProps) {
  return (
    <Paper
      sx={{
        p: 4,
        width: "100%",
        maxWidth: 450,
        minWidth: 300,
        borderRadius: 3,
        mx: "auto",
        boxShadow: "10px 4px 12px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
      }}
    >
      <Box sx={{ mb: 3 }}>
        {type === "circular" ? (
          <CircularProgress
            size={50}
            sx={{
              color: "primary.main",
              mb: 2,
            }}
          />
        ) : (
          <LinearProgress
            sx={{
              height: 6,
              borderRadius: 3,
              mb: 2,
            }}
          />
        )}
      </Box>

      <Typography
        variant="h6"
        component="h3"
        sx={{
          mb: 1,
          fontWeight: 600,
          color: "text.primary",
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          lineHeight: 1.5,
        }}
      >
        {message}
      </Typography>
    </Paper>
  );
}
